import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FcGenericItemType,
  FcModifyGenericItemType,
  FindControlDeleteItemResultDto,
  FindControlExportAllDto,
  FindControlExportAllRequestDto,
  FindControlExportItemsDto,
  FindControlExportItemsRequestDto,
  FindControlImportItemsRequestDto,
  FindControlInitDto,
  FindControlResultDto,
  FindControlUserColumnsConfigDto,
  GetDataSearchDto,
  GetMfuSearchDto,
  GetMruSearchDto,
  IColumnPk,
} from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FindControlRepository {
  constructor(private httpClientService: PrmHttpClientService) { }

  routePrefix = 'findcontrol';

  exportAll(id: string, exportAllDto: FindControlExportAllRequestDto): Observable<FindControlExportAllDto> {
    const endpointUrl = `${this.routePrefix}/exportall`;
    const params = new HttpParams()
      .set('id', id)
      .set('IncludeSystemItems', exportAllDto.IncludeSystemItems);
    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

  exportItems(id: string, exportItemsDto: FindControlExportItemsRequestDto): Observable<FindControlExportItemsDto> {
    const endpointUrl = `${this.routePrefix}/exportitems`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendPostRequest(endpointUrl, exportItemsDto, params);
  }

  importItems(id: string, importItemsDto: FindControlImportItemsRequestDto): Observable<IColumnPk> {
    const endpointUrl = `${this.routePrefix}/importitems`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendPostRequest(endpointUrl, importItemsDto, params);
  }

  getConfig(id: string): Observable<FindControlInitDto> {
    const endpointUrl = `${this.routePrefix}/initialize`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

  getData(id: string, searchDto: GetDataSearchDto): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/search`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendPostRequest(endpointUrl, searchDto, params);
  }

  getSelectedItems(id: string, guids: string[]): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/selecteditems`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendPostRequest(endpointUrl, guids, params);
  }

  getItem<T = FcGenericItemType>(id: string, itemPk: string): Observable<T> {
    const endpointUrl = `${this.routePrefix}/item/${itemPk}`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }
  updateItem<T = FcModifyGenericItemType>(id: string, itemPk: string, itemDto: T): Observable<IColumnPk> {
    const endpointUrl = `${this.routePrefix}/item/${itemPk}`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendPutRequest(endpointUrl, itemDto, params);
  }
  createItem<T = FcModifyGenericItemType>(id: string, itemDto: T): Observable<IColumnPk> {
    const endpointUrl = `${this.routePrefix}/item`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendPutRequest(endpointUrl, itemDto, params);
  }

  getMruList(id: string, maxrows: number, searchDto: GetMruSearchDto): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/mrulist`;
    const params = new HttpParams()
      .set('id', id)
      .set('maxRows', '' + maxrows);
    return this.httpClientService.sendPostRequest(endpointUrl, searchDto, params);
  }

  getMfuList(id: string, maxrows: number, searchDto: GetMfuSearchDto): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/mfulist`;
    const params = new HttpParams()
      .set('id', id)
      .set('maxRows', '' + maxrows);
    return this.httpClientService.sendPostRequest(endpointUrl, searchDto, params);
  }

  updateMfuMruList(id: string, guids: string[]): Observable<string[]> {
    const endpointUrl = `${this.routePrefix}/updatemfumru`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendPostRequest(endpointUrl, guids, params);
  }

  deleteItem(id: string, controlId: string): Observable<FindControlDeleteItemResultDto> {
    const endpointUrl = `${this.routePrefix}/delete/${controlId}`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendDeleteRequest(endpointUrl, params);
  }

  canDeleteItem(id: string, controlId: string): Observable<FindControlDeleteItemResultDto> {
    const endpointUrl = `${this.routePrefix}/can-delete/${controlId}`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendDeleteRequest(endpointUrl, params);
  }

  mergeItem(id: string, controlId: string, newId: string): Observable<FindControlDeleteItemResultDto> {
    const endpointUrl = `${this.routePrefix}/merge/${controlId}`;
    const params = new HttpParams()
      .set('id', id)
      .set('newId', '' + newId);
    return this.httpClientService.sendDeleteRequest(endpointUrl, params);
  }

  updateUserColumnsConfig(id: string, config: FindControlUserColumnsConfigDto): Observable<FindControlInitDto> {
    const endpointUrl = `${this.routePrefix}/update-user-columns-config`;
    const params = new HttpParams().set('id', id);
    return this.httpClientService.sendPostRequest(endpointUrl, config, params);
  }
}
